export const BASE_URL =
    process.env.NODE_ENV === 'development' ? 'http://localhost:3000/mijnps' : 'https://psapi.partnerselect.net/mijnps';
